import { UnnamedWidget } from 'lib-node-amb-renderer';

import CalculationHistoryComponent from '~/pages/IncomeCalculator/CalculationHistory/CalculationHistory';

export class CalculationHistoryClass extends UnnamedWidget {
  constructor(props) {
    super(props);
    this.sx = props.sx;
  }

  execute(data, props) {
    return super.execute(data, props);
  }
}

const defaultSx = {
  marginTop: '.5rem',
};

type CalculationHistoryProps = {
  sx?: any;
};

const CalculationHistory = ({ sx = {} }: Readonly<CalculationHistoryProps>) => {
  return <CalculationHistoryComponent sx={{ ...defaultSx, ...sx }} />;
};

export default CalculationHistory;
